import GraphIcon from './component.jsx'
export default GraphIcon
